var _defs, _style;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFeatSmokeAlarm = function SvgFeatSmokeAlarm(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Calque_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 15.28 15.279999",
    width: 15.28,
    height: 15.28,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs189"
  })), _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css",
    id: "style182"
  }, "\n\t.st0{fill-rule:evenodd;clip-rule:evenodd;}\n")), /*#__PURE__*/React.createElement("path", {
    d: "m 7.64,0.1 c 4.16,0 7.54,3.37 7.54,7.54 0,4.17 -3.37,7.54 -7.54,7.54 C 3.47,15.18 0.1,11.81 0.1,7.64 0.1,3.47 3.48,0.1 7.64,0.1 Z m 0,1 c -3.61,0 -6.53,2.92 -6.53,6.53 0,3.61 2.92,6.53 6.53,6.53 3.61,0 6.53,-2.92 6.53,-6.53 C 14.17,4.02 11.25,1.1 7.64,1.1 Z M 5.18,8.14 c 0.2,0.99 0.97,1.76 1.96,1.96 v 1.02 C 5.6,10.9 4.38,9.68 4.16,8.14 Z m 4.92,0 h 1.02 C 10.9,9.68 9.68,10.9 8.14,11.12 V 10.1 C 9.13,9.9 9.9,9.13 10.1,8.14 Z M 7.64,6.13 c 0.83,0 1.51,0.67 1.51,1.51 0,0.84 -0.68,1.5 -1.51,1.5 -0.83,0 -1.51,-0.67 -1.51,-1.5 0,-0.83 0.68,-1.51 1.51,-1.51 z m 0,1 c -0.28,0 -0.5,0.22 -0.5,0.5 0,0.28 0.22,0.5 0.5,0.5 0.28,0 0.5,-0.22 0.5,-0.5 0,-0.27 -0.22,-0.5 -0.5,-0.5 z m 0.5,-2.98 c 1.54,0.22 2.76,1.44 2.98,2.98 H 10.1 C 9.9,6.15 9.13,5.37 8.14,5.17 Z m -1,0 V 5.17 C 6.15,5.37 5.38,6.15 5.18,7.13 H 4.16 C 4.38,5.59 5.59,4.38 7.14,4.15 Z m 4.02,-0.53 c 0.28,0 0.5,0.22 0.5,0.5 0,0.28 -0.22,0.5 -0.5,0.5 -0.28,0 -0.5,-0.22 -0.5,-0.5 0,-0.28 0.22,-0.5 0.5,-0.5 z",
    id: "path184",
    style: {
      fill: "#7f7f7f",
      fillOpacity: 1,
      stroke: "#7f7f7f",
      strokeWidth: 0.2,
      strokeDasharray: "none",
      strokeOpacity: 1
    }
  }));
};
export default SvgFeatSmokeAlarm;